import React, { useState } from 'react';
import PlayButton from "../images/gif/play-gif-unscreen.gif"
import Imageone from '../Video/akt-powder-coating-gif/SprayMachinetwo.gif';
import Imagetwo from '../Video/akt-powder-coating-gif/Surface Finishing.gif';
import Imagethree from '../Video/akt-powder-coating-gif/powdercoating.gif';
import Videoone from '../Video/akt-powder-coating-video/Spray Machine.mp4';
import Videotwo from '../Video/akt-powder-coating-video/Surface Finishing.mp4';
import Videothree from '../Video/akt-powder-coating-video/Powder Coating.mp4';


const videoData = [
    {
        id: 1,
        title: 'One',
        videoUrl: Videoone,
        image: Imageone,
    },
    {
        id: 2,
        title: 'Two',
        videoUrl: Videotwo,
        image: Imagetwo,
    },
    {
        id: 3,
        title: 'Three',
        videoUrl: Videothree,
        image: Imagethree,
    },
];

function Videobox() {
    const [selectedVideo, setSelectedVideo] = useState(null);

    const openModal = (video) => {
        setSelectedVideo(video);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedVideo(null);
        document.body.style.overflow = 'auto';
    };

    return (
        <div className="py-3 px-4 mb-2">
            {/* Video Thumbnails */}
            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-3">
                {videoData.map((video) => (
                    <div
                        key={video.id}
                        className="relative bg-white rounded-2xl overflow-hidden aspect-video cursor-pointer group"
                        onClick={() => openModal(video)}
                    >
                        <img
                            src={video.image}
                            alt={video.title}
                            className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <img src={PlayButton} alt="Play Button" className='h-20 rounded-full bg-black/45 hover:bg-[#0c2340]' />
                        </div>
                    </div>
                ))}
            </div>

            {/* Video Modal */}
            {selectedVideo && (
                <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
                    <div className="relative bg-black rounded-xl overflow-hidden max-w-3xl w-full aspect-video shadow-2xl">
                        <video
                            src={selectedVideo.videoUrl}
                            controls
                            autoPlay
                            playsInline
                            controlsList="nodownload noremoteplayback"
                            disablePictureInPicture
                            onContextMenu={(e) => e.preventDefault()}
                            className="w-full h-full object-contain"
                        />
                        <button
                            onClick={closeModal}
                            className="absolute top-1 right-1 text-white bg-red-500 hover:bg-red-600 rounded-lg p-2 text-sm"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Videobox;
